import React from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import LandingPage from './routes/LandingPage'
import SubscriptionPage from './routes/SubscriptionPage'
import HomePage from './routes/HomePage'
import GamePage from './routes/GamePage'
import LoginPage from './routes/LoginPage'
import OtpPage from './routes/OtpPage'
import LeaderboardPage from './routes/LeaderboardPage'
import ProfilePage from './routes/ProfilePage'
import WinnersPage from './routes/WinnersPage'
import CategoryPage from './routes/CategoryPage'
import LanguageSelector from './component/LanguageSelector'
import PrivacySupplement from './routes/PrivacySupplement'
import SettingsPage from './routes/SettingsPage'
import Privacy from './routes/Privacy'
import MyGames from './routes/MyGames'

const App = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <>
        <LandingPage />
        <LanguageSelector />
      </>
    },
    {
      path: "/subscribe",
      element:
        <>
          <SubscriptionPage />
          <LanguageSelector />
        </>
    },
    {
      path: "/login",
      element:
        <>
          <LoginPage />
          <LanguageSelector />
        </>
    },
    {
      path: "/privacy-supplement",
      element: <>
        <PrivacySupplement />
      </>
    },
    {
      path: "/otp",
      element:
        <>
          <OtpPage />
          <LanguageSelector />
        </>
    },
    {
      path: "/home",
      element:
        <>
          <HomePage />
          <LanguageSelector />
        </>
    },
    {
      path: "/category",
      element:
        <>
          <CategoryPage />
          <LanguageSelector />
        </>
    },
    {
      path: "/game",
      element: <GamePage />
    },
    {
      path: "/winners",
      element:
        <>
          <WinnersPage />
          <LanguageSelector />
        </>
    },
    {
      path: "/leaderboard",
      element:
        <>
          <LeaderboardPage />
          <LanguageSelector />
        </>
    },
    {
      path: "/profile",
      element:
        <>
          <ProfilePage />
          <LanguageSelector />
        </>
    },
    {
      path:"/my-games",
      element:
      <>
      <MyGames />
      <LanguageSelector />
      </>
    },
    {
      path: "/settings",
      element: <>
        <SettingsPage />
        <LanguageSelector />
      </>
    },
    {
      path:"/privacy",
      element:<>
      <Privacy />
      </>
    }
  ])
  return (
    <RouterProvider router={router} />
  )
}

export default App